import {styled} from "@mui/material/styles"
import {Box as MUIBox, Tab as MUITab, Chip as MUIChip, Tabs as MUITabs} from "@mui/material"
import {breakpoints} from "@next/ux-fabric"

export const Box = styled(MUIBox)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0.5rem 0 0.45rem 0.7rem;

    @media (min-width: ${breakpoints.values.lg}px) {
        padding: 0;
        flex-direction: row;
        align-items: center;
    }
`

export const Title = styled("div")`
    font-size: 0.875rem;
    font-weight: 500;
    white-space: nowrap;
    padding: 0 0 0.2rem 0.3rem;
    color: ${({theme}) => theme.uxfabric.text.primary};

    @media (min-width: ${breakpoints.values.lg}px) {
        padding-left: 1rem;
        padding-bottom: 0;
    }
`

export const Wrapper = styled("div")`
    display: flex;
    min-height: 3rem;
    align-items: center;
`
export const Container = styled("div")`
    width: 100%;
`

export const Tabs = styled(MUITabs)`
    position: relative;
    width: 100%;
    .MuiTabs-scroller {
        width: 1px;
    }
`

export const Tab = styled(MUITab)`
    padding: 0 0.313rem 0 0.313rem;
    min-width: 0;

    &.Mui-focusVisible {
        outline: 0;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        //This is done due to MUI issue https://github.com/mui/material-ui/issues/29033. The solution provided in:
        //  https://github.com/mui/material-ui/blob/master/packages/mui-material/src/Chip/Chip.d.ts is not in master currently.
        &:last-child {
            padding-right: 1.5rem;
        }
        &:first-child {
            padding-left: 1rem;
        }
    }
`

export const Chip = styled(MUIChip)`
    .MuiTouchRipple-root {
        display: none;
    }

    .MuiChip-label {
        line-height: 1.5;
        font-weight: 400;
        text-transform: none;
    }

    &.MuiChip-clickable:hover,
    &.Mui-focusVisible {
        background-color: transparent;
    }

    border: 0.063rem solid ${({theme}) => theme.uxfabric.primary.main};
    font-size: 0.813rem;
    height: 2.125rem;

    @media (min-width: ${breakpoints.values.lg}px) {
        font-size: 0.75rem;
        height: 1.5rem;
    }
`
